export const checkHostConnection = () => {
    const host = document.location.origin;
    return fetch(host).then(() => true, () => false);
};
